export interface ToolbarConfig {
  title?: string;
  showBackButton?: boolean;
  backButtonAction?: () => void;
  showMenuButton?: boolean;
  menuButtonAction?: () => void;
  elevation?: number; // 0-5 (Material Design elevation levels)
  logoImage?: string; // Caminho para imagem do logo
  logoAlt?: string; // Texto alternativo para o logo
  logoAlign?: 'left' | 'center'; // Alinhamento do logo
  hideSpacers?: boolean; // Ocultar spacers quando não há botões
}

export class ToolbarComponent {
  /**
   * Renderiza uma toolbar no estilo Material Design 3
   */
  static render(config: ToolbarConfig = {}): string {
    const {
      title = '',
      showBackButton = false,
      showMenuButton = false,
      elevation = 2,
      logoImage,
      logoAlt = 'Logo',
      logoAlign = 'center',
      hideSpacers = false
    } = config;

    const elevationClass = `toolbar-elevation-${elevation}`;
    const logoAlignClass = logoAlign === 'left' ? 'toolbar-logo-left' : '';

    const leftElement = showBackButton 
      ? this.renderBackButton() 
      : (hideSpacers ? '' : '<div class="toolbar-spacer"></div>');
    
    const rightElement = showMenuButton 
      ? this.renderMenuButton() 
      : (hideSpacers ? '' : '<div class="toolbar-spacer"></div>');

    return `
      <div class="md3-toolbar ${elevationClass}">
        ${leftElement}
        <div class="toolbar-content ${logoAlignClass}">
          ${logoImage && !title ? this.renderLogo(logoImage, logoAlt) : ''}
          ${title ? `<div class="toolbar-title">${this.escapeHtml(title)}</div>` : ''}
        </div>
        ${rightElement}
      </div>
    `;
  }

  private static renderBackButton(): string {
    return `
      <button class="toolbar-button toolbar-back-button" id="toolbar-back-btn" aria-label="Voltar">
        <svg class="toolbar-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="currentColor"/>
        </svg>
      </button>
    `;
  }

  private static renderMenuButton(): string {
    return `
      <button class="toolbar-button toolbar-menu-button" id="toolbar-menu-btn" aria-label="Menu">
        <svg class="toolbar-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" fill="currentColor"/>
        </svg>
      </button>
    `;
  }

  private static renderLogo(imagePath: string, alt: string): string {
    return `
      <img src="${this.escapeHtml(imagePath)}" alt="${this.escapeHtml(alt)}" class="toolbar-logo" />
    `;
  }

  /**
   * Anexa eventos aos botões da toolbar
   */
  static attachEvents(container: HTMLElement, config: ToolbarConfig): void {
    if (config.showBackButton && config.backButtonAction) {
      const backBtn = container.querySelector('#toolbar-back-btn');
      if (backBtn) {
        backBtn.addEventListener('click', config.backButtonAction);
      }
    }

    if (config.showMenuButton && config.menuButtonAction) {
      const menuBtn = container.querySelector('#toolbar-menu-btn');
      if (menuBtn) {
        menuBtn.addEventListener('click', config.menuButtonAction);
      }
    }
  }

  private static escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

